import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import * as S from "./style"

import { CTAOfferButton } from "../../common/styled-components/styled-components";
import Image from '../../../../app/js/components/loggedout/common/Image';
import { whiteLilac } from '../../../../app/js/components/loggedout/shared-styles/Colors';

import GifOverlayWeb from '~images/loggedout/home/gif_overlay_web.png';
import BookImage from "~images/sem/main-section/book.png";
import FunnelImage from "~images/sem/main-section/funnel.png";
import YellowCartoon from "~images/sem/main-section/yellow_cartoon.png";
import OutlineStar from "~images/sem/main-section/outline_star.png";
import Star from "~images/sem/main-section/star.png";
import NumberImg from '~images/sem/purchase/num.png';

import VideoModal from '../main-section-video/videoModal';
import Routes from '../../routes/routes';
import i18n from '../../../../app/js/utils/i18n';
import { SemContext } from "../../context/SemContext";

const MainSection = ({ settings, trackPromoPageEvents }) => {
  const [showVideoOverlay, setShowVideoOverlay] = React.useState(false);

  const onPlayClickHandler = () => {
    console.info('starting video play');
    trackPromoPageEvents("Promo Page Interacted",{"clicked_on" : "video_started"}, true);
    setShowVideoOverlay(true);
  }

  const videoOverlayCloseHandler = () => {
    setShowVideoOverlay(false);
    location.pathname = Routes.PURCHASE_ROUTE;
  }

  const { state } = useContext(SemContext);
  const cta_text = (state.settings && state.settings.button_text) || "Try for free";
  const headerText = (state.settings && state.settings.heading_text) || "Try SplashLearn FREE for 7 days!"

  return (
    <S.Wrapper>
      <S.BackgroundImage>
        <S.ContentWrapper>
          <S.Stripe>
            <p> {i18n.t("sem.title")} </p>
          </S.Stripe>
          <S.ContentTitle>
            {headerText}
          </S.ContentTitle>
        </S.ContentWrapper>
        <S.ImageWrapper>
          <Image src={OutlineStar} className="outline-star" />
          <Image src={settings.offer_image} isCdnImage={true}></Image>
          <Image src={GifOverlayWeb}></Image>
          <S.CartoonContainer>
            <Image src={YellowCartoon} />
          </S.CartoonContainer>
          <S.PlayButtonContainer onClick={() => onPlayClickHandler()}>
            <S.PlayButton></S.PlayButton>
            <p>KNOW MORE</p>
          </S.PlayButtonContainer>
          {showVideoOverlay && settings.offer_video &&
            <VideoModal videoSrc={settings.offer_video} videoOverlayCloseHandler={videoOverlayCloseHandler} trackPromoPageEvents={trackPromoPageEvents}/>
          }
        </S.ImageWrapper>
      </S.BackgroundImage>
      <S.BackgroundCurve>
        <S.ContentWrapper>
          <S.ContentTitle curveTitle={true}>
            {headerText}
          </S.ContentTitle>
          <S.Stripe curveStripe={true}>
            <p>{i18n.t("sem.title")}</p>
          </S.Stripe>
        </S.ContentWrapper>
        <S.ExtraInfoWrapper>
          <S.ExtraInfo>
            <S.InfoIcon firstInfoIcon={'img'}>
              <Image
                src={NumberImg}
                alt="4000"
              ></Image>
            </S.InfoIcon>
            <S.InfoIcon firstInfoIcon={'text'}>
              <p>4000+</p>
            </S.InfoIcon>
            <S.Info bottomText={true}>
              <p>
                Curriculum aligned skills
              </p>
            </S.Info>
          </S.ExtraInfo>
          <S.ExtraInfo>
            <S.InfoIcon>
              <Image
                src={BookImage}
                alt="Detailed Reports"
              ></Image>
            </S.InfoIcon>
            <S.Info>
              <p>
                Detailed Reports
              </p>
            </S.Info>
          </S.ExtraInfo>
          <S.ExtraInfo>
            <S.InfoIcon>
              <Image
                src={FunnelImage}
                alt="safe_image"
              ></Image>
            </S.InfoIcon>
            <S.Info>
              <p>
                Designed by Experts
              </p>
            </S.Info>
          </S.ExtraInfo>
        </S.ExtraInfoWrapper>
        {settings.offer_text && <S.CurveOfferText>
          <Image src={Star}></Image>
          <span>{settings.offer_text}</span>
          <Image src={Star}></Image>
        </S.CurveOfferText>
        }
        <S.ButtonWrapper>
          <CTAOfferButton hoverColor={whiteLilac}>
            <Link to={Routes.PURCHASE_ROUTE} onClick={()=>trackPromoPageEvents("Promo Page Interacted", {'clicked_on' : 'CTA1'}, true)}>
              {cta_text}
            </Link>
          </CTAOfferButton>
        </S.ButtonWrapper>
      </S.BackgroundCurve>
    </S.Wrapper>
  )
}

export default MainSection 
